import { render } from "./index.vue?vue&type=template&id=c74e85d6"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=c74e85d6&lang=css"
script.render = render

export default script